export const ADMINS = ['anand', 'ravikiran'];
